<div
  #wrapperImage
  [ngClass]="{
    'no-aspect-full': !keepAspectRatio() && !isFullWidth(),
    'no-aspect-size-full': !keepAspectRatio() && isFullWidth(),
  }"
  class="wrapper-image">
  @if (isLoading() && showLoadingPlaceholder()) {
    <div [ngStyle]="{ 'width.px': width(), 'height.px': height() }" class="loading-placeholder"></div>
  }

  @if (isError()) {
    <div [ngStyle]="{ 'width.px': width(), 'height.px': height() }" class="error-placeholder">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
        stroke-width="1.5"
        stroke="currentColor"
        class="error-icon">
        <path
          stroke-linecap="round"
          stroke-linejoin="round"
          d="M3.98 8.223A10.477 10.477 0 0 0 1.934 12C3.226 16.338 7.244 19.5 12 19.5c.993 0 1.953-.138 2.863-.395M6.228 6.228A10.451 10.451 0 0 1 12 4.5c4.756 0 8.773 3.162 10.065 7.498a10.522 10.522 0 0 1-4.293 5.774M6.228 6.228 3 3m3.228 3.228 3.65 3.65m7.894 7.894L21 21m-3.228-3.228-3.65-3.65m0 0a3 3 0 1 0-4.243-4.243m4.242 4.242L9.88 9.88" />
      </svg>
    </div>
  } @else {
    @if (width() && height() && imagesArray()) {
      @for (image of imagesArray(); track image.randomId) {
        <div
          [ngClass]="{ 'relative-image': !isFullWidth(), 'w-full-image': isFullWidth() }"
          [ngStyle]="isFullWidth() ? { 'height.px': height() } : { 'width.px': width(), 'height.px': height() }"
          class="image-wrapper">
          <img
            (load)="setLoadingFalse()"
            (error)="onError()"
            class="image-cover"
            [alt]="image.alt"
            [ngSrc]="image.cdnLink ?? ''"
            [title]="image.title"
            [priority]="isPriority()"
            fill />
        </div>
      }
    }
  }
</div>
